import { ThunkType } from "../../../../core/store/reducers";
import getEtfSummaryApi from "../api/getEtfSummary";
import { setDisplayedEtfSummary } from "../statisticsDataSlice";
import { EtfSummaryItem } from "../types";

// Load funkcija (reset + fetch)
export const loadEtfSummary = (
	symbol: string
): ThunkType => async (dispatch, getStore) => {
	// reset prethodnih podataka
	dispatch(setDisplayedEtfSummary(undefined));

	console.log(symbol)
	const etfsummary = await dispatch(
		getEtf_Summary(symbol)
	);
	console.log(etfsummary)

	dispatch(setDisplayedEtfSummary(etfsummary));
};

export const getEtf_Summary = (
	symbol: string
): ThunkType<Promise<EtfSummaryItem | undefined>> =>
	async (dispatch, getStore, _extra) => {

		const store = getStore();

		if (store.data.auth.current.status !== "successful") {
			return undefined;
		}

		const { userId } = store.data.auth.current.user;

		const response = await dispatch(
			getEtfSummaryApi(userId, symbol, "etfs/world/summary")
		);


		console.log(response)
		if (!response || !response.etf) {
			return undefined;
		}

		const { etf } = response;

		return {
			symbol: etf.summary.symbol,
			share_class_inception_date: etf.summary.share_class_inception_date,
			ytd_return: response.etf.summary.ytd_return,
			expense_ratio_net: response.etf.summary.expense_ratio_net,
			yield: response.etf.summary.yield,
			nav: response.etf.summary.nav,
			last_price: response.etf.summary.last_price,
			turnover_rate: response.etf.summary.turnover_rate,
			net_assets: response.etf.summary.net_assets,
		};
	};